module.exports = __webpack_public_path__ + "static/media/x.e86bb1d2.svg";